import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";
import "nprogress/nprogress.css";
import constantRoutes from "@/router/modules/constantRoutes";

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: constantRoutes as RouteRecordRaw[],
});

// The removal handles of every dynamically added route. `router.removeRoute(name)` only reaches
// named records, and some async records have no name (layout parents such as
// `/profile/mailboxes`): through their handle they go as well, children included.
let addedRoutes: Array<() => void> = [];

export function resetRouter() {
  addedRoutes.forEach((remove) => remove());
  addedRoutes = [];
}

export function addRoutes(routes: RouteRecordRaw[]) {
  routes.forEach((route) => {
    addedRoutes.push(router.addRoute(route));
  });
}

// Navigation guard - only toggles the branded auth background; auth logic is in permission.ts.
// The `authBackground` meta flag on the route (constantRoutes) is the single source of truth,
// so this stays in sync with the routes automatically. classList.toggle leaves any other
// body classes untouched (unlike the previous `body.className = ...` which clobbered them).
router.beforeEach((to) => {
  const isAuthBackground = to.matched.some((record) => record.meta.authBackground);

  document.body.classList.toggle("auth-bg", isAuthBackground);

  return true;
});

export default router;
